import { setAsyncStorage } from 'parse';

var moment = require('moment');
// initial state
const state = {

  welcomeMessage: null,
  weeklySponsorImage:null,
  weeklySponsorLink:null,
  partners:{
    partnerOneImage:null,
    partnerOneLink: null,
    partnerOnePromo:null,

    partnerTwoImage:null,
    partnerTwoLink: null,
    partnerTwoPromo:null,

    partnerThreeImage:null,
    partnerThreeLink: null,
    partnerThreePromo:null,

    partnerFourImage:null,
    partnerFourLink: null,
    partnerFourPromo:null,

    partnerFiveImage:null,
    partnerFiveLink: null,
    partnerFivePromo:null,

    partnerSixImage:null,
    partnerSixLink: null,
    partnerSixPromo:null,

    partnerSevenImage:null,
    partnerSevenLink: null,
    partnerSevenPromo:null,

    partnerEightImage:null,
    partnerEightLink: null,
    partnerEightPromo:null,

    partnerNineImage:null,
    partnerNineLink: null,
    partnerNinePromo:null,

    partnerTenImage:null,
    partnerTenLink: null,
    partnerTenPromo:null,
  }
};

// getters
const getters = {
  welcomeMessage: state => state.welcomeMessage,
  weeklySponsorImage: state => state.weeklySponsorImage,
  weeklySponsorLink: state => state.weeklySponsorLink,
  partners: state => state.partners
};

// actions
const actions = {
  getSettings (context, week) {
    var settingsQuery = new Parse.Query('Settings');
    settingsQuery.equalTo('week', week);
    settingsQuery.first().then(settingObject => {
      if(settingObject){
        context.commit('setSettings', settingObject);
      }
    });
  }
};

// mutations
const mutations = {
  setWelcomeMessage(state, messages){
    console.log('hello')
    state.welcomeMessage = messages;
  },
  setSettings (state, settingObject) {
    state.welcomeMessage = settingObject.get('welcomeMessage');
    state.weeklySponsorImage = settingObject.get('weeklySponsorImage');
    state.weeklySponsorLink = settingObject.get('weeklySponsorLink');

    state.partners.partnerOneImage = settingObject.get('partnerOneImage');
    state.partners.partnerOneLink = settingObject.get('partnerOneLink');
    state.partners.partnerOnePromo = settingObject.get('partnerOnePromo');

    state.partners.partnerTwoImage = settingObject.get('partnerTwoImage');
    state.partners.partnerTwoLink = settingObject.get('partnerTwoLink');
    state.partners.partnerTwoPromo = settingObject.get('partnerTwoPromo');

    state.partners.partnerThreeImage = settingObject.get('partnerThreeImage');
    state.partners.partnerThreeLink = settingObject.get('partnerThreeLink');
    state.partners.partnerThreePromo = settingObject.get('partnerThreePromo');

    state.partners.partnerFourImage = settingObject.get('partnerFourImage');
    state.partners.partnerFourLink = settingObject.get('partnerFourLink');
    state.partners.partnerFourPromo = settingObject.get('partnerFourPromo');

    state.partners.partnerFiveImage = settingObject.get('partnerFiveImage');
    state.partners.partnerFiveLink = settingObject.get('partnerFiveLink');
    state.partners.partnerFivePromo = settingObject.get('partnerFivePromo');

    state.partners.partnerSixImage = settingObject.get('partnerSixImage');
    state.partners.partnerSixLink = settingObject.get('partnerSixLink');
    state.partners.partnerSixPromo = settingObject.get('partnerSixPromo');

    state.partners.partnerSevenImage = settingObject.get('partnerSevenImage');
    state.partners.partnerSevenLink = settingObject.get('partnerSevenLink');
    state.partners.partnerSevenPromo = settingObject.get('partnerSevenPromo');


    state.partners.partnerEightImage = settingObject.get('partnerEightImage');
    state.partners.partnerEightLink = settingObject.get('partnerEightLink');
    state.partners.partnerEightPromo = settingObject.get('partnerEightPromo');

    state.partners.partnerNineImage = settingObject.get('partnerNineImage');
    state.partners.partnerNineLink = settingObject.get('partnerNineLink');
    state.partners.partnerNinePromo = settingObject.get('partnerNinePromo');

    state.partners.partnerTenImage = settingObject.get('partnerTenImage');
    state.partners.partnerTenLink = settingObject.get('partnerTenLink');
    state.partners.partnerTenPromo = settingObject.get('partnerTenPromo');
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}
